import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/sass/index.scss";
import "./assets/js/firebase.js";
import Rellax from "rellax";
import { updateGlobalOptions, toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

const app = createApp(App);

app.use(router);
app.use(
  updateGlobalOptions({
    autoClose: 2500,
    position: toast.POSITION.TOP_CENTER,
    transition: toast.TRANSITIONS.SLIDE,
    hideProgressBar: true,
  })
);

router.isReady().then(() => {
  app.mount("#app");
});

const globalMixin = {
  mounted() {
    // Check if there are elements with the "rellax" class
    const rellaxElements = document.querySelectorAll(".rellax");
    if (rellaxElements.length > 0) {
      // Initialize Rellax within the mounted hook
      new Rellax(".rellax");
    }
  },
};

app.mixin(globalMixin);
